import React from 'react';

import { Accordion } from '@infoods/lifebase-ui';

import classes from './FaqBlock.module.scss';

import { CollapsableInfoBox } from '../../../../shared/components/ui-components';
import { RichTextViewer } from '../../../../shared/features/rich-text';
import { ChallengeFaqsInfo } from '../../../interfaces/ChallengeInfo';

type FaqBlockProps = {
  defaultOpen: boolean;
  faqs: ChallengeFaqsInfo;
};

const FaqBlock = ({ defaultOpen, faqs }: FaqBlockProps) => {
  const faqList = faqs.faqs ?? [];

  if (!faqs.enabled || faqList.length === 0) {
    return null;
  }

  return (
    <CollapsableInfoBox
      title="FAQ"
      defaultOpen={defaultOpen}
      customContentPadding
      customMargin
    >
      <div className={classes.faqContainer}>
        {faqList.map((faq) => {
          if (!faq.question || !faq.answer) {
            return null;
          }

          return (
            <Accordion
              key={faq.questionNum}
              className={classes.faqItem}
              title={faq.question}
            >
              <RichTextViewer content={faq.answer} />
            </Accordion>
          );
        })}
      </div>
    </CollapsableInfoBox>
  );
};

export { FaqBlock };
